import { render, staticRenderFns } from "./editTextarea.vue?vue&type=template&id=622ce5f4&scoped=true"
import script from "./editTextarea.vue?vue&type=script&lang=js"
export * from "./editTextarea.vue?vue&type=script&lang=js"
import style0 from "./editTextarea.vue?vue&type=style&index=0&id=622ce5f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622ce5f4",
  null
  
)

export default component.exports